/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

/**
 * This method retrieves the contact details from amazon connect.
 */
export const getContactDetails = (contact) => {
	const contactInfo = {
		contactId: contact.getContactId(),
	};

	const queue = contact.getQueue();

	if (queue) {
		contactInfo.queue = queue.name;
	}

	contactInfo.type = contact.getType();
	contactInfo.phone = contactInfo.contactId;

	if (contactInfo.type === "voice") {
		const activeEndpoint = contact.getActiveInitialConnection() && contact.getActiveInitialConnection().getEndpoint();
		if (activeEndpoint) {
			contactInfo.phone = activeEndpoint.phoneNumber;
		}
	}

	return contactInfo;
};

export const getContactAttributes = (contact) => {
	const attributes = contact.getAttributes();
	if (!attributes) {
		return [];
	}

	const filteredAttributes = Object.values(attributes).filter((e) => !e.name.startsWith("_"));
	return Object.values(filteredAttributes); // returns [{ name: "", value: "" }, ... ]
};
